module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10080.82864e16.jpg";